import { render } from "./SearchLayout.vue?vue&type=template&id=2e7e6c80"
import script from "./SearchLayout.vue?vue&type=script&lang=js"
export * from "./SearchLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__